import { getAuth } from "firebase/auth";
import { addUserAction, saveUserCart, getUserCart } from "./functionFirebase";

// إضافة منتج للسلة
export async function addToCart(product, currentCart) {
  const auth = getAuth();
  const user = auth.currentUser;
  if (user) {
    let cart = Array.isArray(currentCart) ? [...currentCart] : [];
    const existing = cart.find((item) => item.id === product.id);
    if (existing) return;
    cart.push({ ...product, quantity: 1 });
    await saveUserCart(user.uid, cart);
    addUserAction({
      type: "add_to_cart",
      date: new Date().toISOString(),
      product,
    });
  } else {
    let cart = JSON.parse(localStorage.getItem("cart")) || [];
    const existing = cart.find((item) => item.id === product.id);
    if (existing) return;
    cart.push({ ...product, quantity: 1 });
    localStorage.setItem("cart", JSON.stringify(cart));
  }
}

// جلب السلة (بدون تغيير)
export async function getCart() {
  const auth = getAuth();
  const user = auth.currentUser;
  if (user) {
    const res = await getUserCart(user.uid);
    return res.success ? res.cart : [];
  } else {
    return JSON.parse(localStorage.getItem("cart")) || [];
  }
}

// حذف منتج من السلة
export async function removeFromCart(id, currentCart) {
  const auth = getAuth();
  const user = auth.currentUser;
  if (user) {
    let cart = Array.isArray(currentCart) ? [...currentCart] : [];
    cart = cart.filter((item) => item.id !== id);
    await saveUserCart(user.uid, cart);
  } else {
    let cart = JSON.parse(localStorage.getItem("cart")) || [];
    cart = cart.filter((item) => item.id !== id);
    localStorage.setItem("cart", JSON.stringify(cart));
  }
}

// تعديل كمية منتج
export async function updateCartQuantity(id, quantity, currentCart) {
  const auth = getAuth();
  const user = auth.currentUser;
  if (user) {
    let cart = Array.isArray(currentCart) ? [...currentCart] : [];
    cart = cart.map((item) =>
      item.id === id ? { ...item, quantity: Math.max(1, quantity) } : item
    );
    await saveUserCart(user.uid, cart);
  } else {
    let cart = JSON.parse(localStorage.getItem("cart")) || [];
    cart = cart.map((item) =>
      item.id === id ? { ...item, quantity: Math.max(1, quantity) } : item
    );
    localStorage.setItem("cart", JSON.stringify(cart));
  }
}


